import { useState } from "react";
import type { UpdateMediaSettingsPayload } from "@circle-react/api/mediaSettingsApi";
import type { MediaSetting } from "@circle-react/types/MediaSetting";
import { Form } from "@circle-react-uikit/Form";
import { AnalyticsTab } from "./AnalyticsTab";
import { EditTab } from "./EditTab";
import { formId } from "./constants";
import type { ModalTab } from "./types";

interface ModalBodyProps {
  mediaSettings: MediaSetting;
  onSubmit: (data: UpdateMediaSettingsPayload) => void;
  selectedTab: ModalTab;
}

export const ModalBody = ({
  mediaSettings,
  onSubmit,
  selectedTab,
}: ModalBodyProps) => {
  const [customThumbnailUrl, setCustomThumbnailUrl] = useState<string | null>(
    mediaSettings.custom_thumbnail_url,
  );

  const defaultValues = {
    custom_thumbnail: mediaSettings.custom_thumbnail_signed_id,
    make_downloadable: mediaSettings.make_downloadable,
    transcript: {
      enabled: mediaSettings.transcript?.enabled ?? false,
      selected_file: mediaSettings.transcript?.selected_file ?? "user",
    },
  };

  return (
    <Form
      id={formId}
      className="h-full"
      formClassName="h-full"
      defaultValues={defaultValues}
      onSubmit={onSubmit}
    >
      {selectedTab === "analytics" && <AnalyticsTab />}
      {selectedTab === "edit" && (
        <EditTab
          mediaSettings={mediaSettings}
          customThumbnailUrl={customThumbnailUrl}
          onCustomThumbnailUrlChange={setCustomThumbnailUrl}
        />
      )}
    </Form>
  );
};
